import { render, staticRenderFns } from "./step-2.vue?vue&type=template&id=bfb9ecae&scoped=true&"
import script from "./step-2.vue?vue&type=script&lang=js&"
export * from "./step-2.vue?vue&type=script&lang=js&"
import style0 from "./step-2.vue?vue&type=style&index=0&id=bfb9ecae&lang=scss&scoped=true&"
import style1 from "./step-2.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb9ecae",
  null
  
)

export default component.exports